export default __webpack_public_path__ + "static/media/clouds@3x.4b7c0080.png";